import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index' // Adjust the import based on your store location
import { Col, Row, Spinner } from 'react-bootstrap'

const Confirmation: React.FC = () => {
  const { loading, error } = useSelector(
    (state: RootState) => state.appointment,
  )

  const isLoadingAdd = loading.add
  const errorAdd = error.add

  return (
    <div className="mt-2 appt-modal">
      {isLoadingAdd && (
        <Row style={{ margin: '100px 0' }}>
          <Col className="text-center">
            <Spinner
              animation="border"
              variant="primary"
              role="status"
              className="appt-spinner"
            />
            <p className="appt-loading-text">Loading...</p>
          </Col>
        </Row>
      )}

      {!isLoadingAdd && errorAdd && (
        <Row style={{ margin: '100px 0' }}>
          <Col className="text-center">
            <i className="appt-failed mgc_close_circle_fill"></i>
            <p>Schedule appointment failed.</p>
          </Col>
        </Row>
      )}

      {!isLoadingAdd && !errorAdd && (
        <Row style={{ margin: '100px 0' }}>
          <Col className="text-center">
            <i
              className="ti ti-circle-check-filled"
              style={{ fontSize: '120px', color: '#3E8E53' }}
            ></i>
            <p>Appointment scheduled successfully.</p>
          </Col>
        </Row>
      )}
    </div>
  )
}

export default Confirmation
